<div class="document-preview">
    <div class="document-preview-layout">
        <img class="image"
            [src]="environment.resourceEndpoint + '/archive/' + preview.previewResourceUUID + '?type=thumb'"
            height="100" *ngIf="preview.type === documentType.PICTURE && previewType === 'PICTURE'" />

        <sc-icon iconClass="fa-file-pdf file-type-icon"
            *ngIf="preview.type === documentType.PICTURE &&  previewType === 'PDF'"></sc-icon>

        <sc-icon iconClass="fa-file file-type-icon"
            *ngIf="preview.type === documentType.PICTURE &&  previewType === 'UNKNOWN'"></sc-icon>

        <div class="title" *ngIf="preview.type === documentType.PICTURE && preview.title">
            {{preview.title | slice:0:100}} {{preview.source}}
        </div>
        <div class="title"
            *ngIf="preview.type === documentType.APP_DOCUMENT && (preview.title || preview.titleDictionaryKey)">
            {{preview.title|translate:[ preview.titleDictionaryKey, translationService.language ]}}
        </div>
        <div class="subtitle" *ngIf="preview.type === documentType.APP_DOCUMENT && preview.subTitle">
            {{preview.subTitle | slice:0:100}}
        </div>
    </div>
    <div class="document-infos">
        <sc-padding>
            <sc-flex >
                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-trash" *ngIf="preview.deletedInTime"></sc-icon>
                <sc-content-spacer *ngIf="preview.source === 'Yard'"></sc-content-spacer>
                <sc-icon iconClass="fa-cloud-arrow-up" *ngIf="preview.source === 'Yard' && preview.publishedInTime"></sc-icon>
                <sc-content-spacer *ngIf="preview.source === 'time_carrier_booking_document'"></sc-content-spacer>
                <sc-icon iconClass="fa-cloud-arrow-down" *ngIf="preview.source === 'time_carrier_booking_document'"></sc-icon>
            </sc-flex>
        </sc-padding>
    </div>
</div>